import {resolveHelpURL} from 'src/utils/url'

export const TRY_PIPELINES_LINK =
  'https://lp.jetbrains.com/teamcity-pipelines-in-enterprise-eap-4708/'

export const TITLE = 'Welcome to TeamCity 2026.1'
export const TEXT = `
This release brings a range of powerful new capabilities, including:

- an MCP endpoint for seamless integration with your preferred AI agents;
- an official CLI tool with AI agent skill;
- major pipeline improvements, including linked pipelines and build configurations in a single chain, support for build features, and more;
- a SAML plugin for authentication via SSO providers.
`.trim()
export const CALL_TO_ACTION_LINK = resolveHelpURL('what-s-new-in-teamcity.html')
export const CALL_TO_ACTION_LABEL = 'Learn more'
